// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"787abb5d","975":"07fafa2d"}[chunkId] + ".chunk.css";
};